module.exports = __webpack_public_path__ + "img/print_logo.2d465167.png";